import { FunctionComponent } from 'react';
import { Grid } from '@material-ui/core';
import { useStateValue } from '../../../providers/StateProvider';
import * as ActionKeys from '../../../store/ActionKeys';
import { useStyles } from './OnsaBanner.styles';

export type Tvariant = 'box' | 'top';

export interface IOnsaBannerProps {
  variant: Tvariant;
  body: string;
  enableToggle: boolean;
  header?: string;
}

const OnsaBanner: FunctionComponent<IOnsaBannerProps> = (props): JSX.Element => {
  const [, dispatch] = useStateValue();
  const baseClass = useStyles();
  const header = props.header || '';
  const bodyHtml = { __html: props.body };

  const toggle = () => {
    if (props.enableToggle) {
      dispatch({ type: ActionKeys.SET_SHOW_BANNER_OVERLAY, payload: true });
    }
  };

  return (
    <div className={`${baseClass.wrapper} ${baseClass[props.variant]}`}>
      {props.variant === 'box' && <div className={baseClass.header}>{header}</div>}
      <Grid container direction="row" justifyContent="center" alignItems="center">
        <span onClick={toggle} className={baseClass.message} dangerouslySetInnerHTML={bodyHtml} />
      </Grid>
    </div>
  );
};

export default OnsaBanner;
